module.exports = __webpack_public_path__ + "img/retail_green.7f12ba34.svg";